import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-behindert',
    templateUrl: './checkbox-field.component.html'
} )
export class DisabilityFormComponent extends AbstractFieldComponent<boolean>   {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.disability' );
    }

    set value( t: boolean | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.disability = t;
        }
    }

    get value(): boolean | undefined {
        return this.jobapplication?.disability;
    }
}
